import React from 'react'
import PropTypes from 'prop-types'

function Table({partners, onEdit, onDelete}) {
  return <table className='table'>
    <thead>
      <tr>
        <th>Name</th>
        <th>Support Email</th>
        <th>Type</th>
        <th className='modify'>Modify</th>
      </tr>
    </thead>
    <tbody>
      { 
        partners.map((partner, index) => {
          return <tr key={index}>
            <td className='name'><a href={`/admins/partners/${partner.id}`}>{partner.name}</a></td>
            <td>{partner.email}</td>
            <td>{partner.kind}</td>
            <td>
              <div className='menu-buttons'>
                <button className='btn btn-primary' onClick={() => onEdit(partner)}>Edit</button>
                <button className='btn btn-danger' onClick={() => onDelete(partner)}>Delete</button>
              </div>
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}

Table.propTypes = {
  partners: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default Table

